module.exports = __webpack_public_path__ + "static/img/jj-logo.180581b2.png";